<template>
  <div class="orderCenter">
    <div class="orderCenter-top">
      <div v-for="(item, index) in navlist" :key="index">
        <div class="top-item" v-if="item.id == data.status">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="orderCenter-bottom">
      <div class="bottom-item">
        <div class="bottom-item-left">
          <div class="bottom-item-left-title1">
            {{ data.tourName }}
          </div>
          <div class="bottom-item-left-title2">
            门票时间：
            {{ data.appointDate }} {{ data.appointTimeStart }}-{{
              data.appointTimeEnd
            }}
          </div>
          <div class="bottom-item-left-title2">
            姓名：
            {{ data.name }}
          </div>
          <div style="font-weight: 600">{{ data.ticketName }}</div>
          <div style="font-weight: 600">总价￥{{ data.price }}</div>
        </div>
      </div>
      <div class="bottom-ticeket border">
        <div class="ticeket-right">
          <div
            class="cancel1"
            style="margin-right: 0.1rem"
            @click="deleteshow = true"
            v-if="getoverdue()"
          >
            {{ text }}
          </div>
          <div
            class="cancel1"
            v-if="data.status == 2"
            @click="myma(data)"
            style="width: 1.2rem"
          >
            点击查看门票码
          </div>
        </div>
      </div>
      <div class="order-item border">
        <div class="title">出行人</div>
        <div class="details-item">姓名：{{ data.name }}</div>
        <div class="details-item">联系方式:{{ data.phone }}</div>
        <div class="details-item">证件号码：{{ data.identity }}</div>
      </div>
      <div class="order-item">
        <div class="title">订单信息</div>
        <div class="details-item" v-if="data.orderId">
          订单编号：{{ data.orderId }}
        </div>
        <div class="details-item">下单时间：{{ data.createTime }}</div>
      </div>
      <div class="order-item" v-if="data.useDesc">
        <div class="title">使用说明</div>
        <div class="desc">{{ data.useDesc }}</div>
      </div>
    </div>
    <el-dialog
      :visible.sync="deleteshow"
      width="70%"
      :show-close="false"
      :close-on-click-modal="false"
      class="el-dialog-centent"
    >
      <div class="pull-con">
        <div class="pull-con-title1">温馨提示</div>
        <div
          class="pull-con-title2"
          v-html="data.returnDesc"
          style="white-space: pre-wrap"
        ></div>
        <div class="pull-button">
          <div
            @click="deleteshow = false"
            style="background-color: rgba(44, 114, 114, 0.3); color: #2c7272"
          >
            取消
          </div>
          <div @click="cancel" style="background-color: #2c7272; color: #fff">
            确定
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="show"
      width="85%"
      :show-close="false"
      class="el-dialog-code"
    >
      <div class="imageMa" v-if="myurl.qrcode">
        <div class="title">{{ myurl.tourName }}</div>
        <img src="../assets/Dotted.png" width="100%" />
        <div style="width: 100%; background-color: #fff">
          <img :src="myurl.qrcode" width="80%" />
        </div>
        <div style="background-color: #fff; font-size: 0.16rem" class="Stitle">
          <span>{{ myurl.appointDate }}</span>
          <span style="margin-left: 4px"
            >{{ myurl.appointTimeStart }}-{{ myurl.appointTimeEnd }}</span
          >
        </div>
        <div class="cancel">
          <div class="cancel-inner" @click="show = false">关闭</div>
        </div>
      </div>
      <div class="imageMa" v-else>
        <div class="title">{{ myurl.tourName }}</div>
        <img src="../assets/Dotted.png" width="100%" />
        <div class="prompt">
          <p>未注册随申码及</p>
          <p>当日新注册随申码用户</p>
          <p style="margin-top: 0.3rem">
            请出示<span style="color: red">随申码</span>入园
          </p>
        </div>
        <div class="cancel">
          <div class="cancel-inner" @click="show = false">关闭</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: "",
      data: "",
      navlist: [
        {
          name: "待付款",
          id: 1,
        },
        {
          name: "已门票",
          id: 2,
        },
        {
          name: "已完成",
          id: 3,
        },
        {
          name: "已退款",
          id: 4,
        },
        {
          name: "已过期",
          id: 5,
        },
        {
          name: "退款中",
          id: 6,
        },
      ],
      //门票码
      myurl: "",
      show: false,
      //退票
      deleteshow: false,
      text: "退款",
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.getdata();
  },
  methods: {
    getdata() {
      this.$axios.get("/book/appointmentInfos?id=" + this.id).then((res) => {
        this.data = res.data.rows[0];
        if (this.data.price == 0) {
          this.text = "取消门票";
        }
      });
    },
    //预览二维码
    myma(url) {
      this.myurl = url;
      this.show = true;
    },
    //点击别处关闭二维码
    onpull($event) {
      if ($event.target.nodeName == "DIV") {
        this.show = false;
        this.myurl = "";
      }
    },
    //退票
    cancel() {
      this.deleteshow = false;
      this.$axios
        .get(
          "/order/refundApply?orderId=" +
            this.data.orderId +
            "&orderDetailId=" +
            this.data.id
        )
        .then((res) => {
          if (res.code == 200) {
            this.getdata();
          } else {
            this.$message.error("退款失败");
          }
        });
    },
    //判断订单是否可退款
    getoverdue() {
      let show = true;
      if (this.data.status != 2 || this.data.isReturn == 1) {
        show = false;
      }
      // else {
      //   let valitem =
      //     new Date(
      //       `${this.data.appointDate} ${this.data.appointTimeEnd}:00`
      //     ).getTime() ||
      //     new Date(
      //       `${this.data.appointDate}T${this.data.appointTimeEnd}:00`
      //     ).getTime();
      //   if (new Date().getTime() > valitem) {
      //     show = false;
      //   }
      // }
      return show;
    },
  },
};
</script>
<style>
.el-dialog-centent {
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-dialog-code {
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-dialog-code .el-dialog {
  background-color: transparent;
}
.el-dialog-code .el-dialog__body {
  padding: 0;
}
.el-dialog {
  margin: 0 0 !important;
  display: flex;
  flex-direction: column;
}
.el-dialog__header {
  display: none;
}
</style>
<style  lang="less" scoped>
.orderCenter {
  .orderCenter-top {
    width: 100%;
    background-color: #2c7272;
    padding: 0 0.2rem;
    box-sizing: border-box;
    .top-item {
      font-size: 0.22rem;
      color: #fff;
      padding-top: 0.3rem;
      height: 0.7rem;
    }
  }
  .orderCenter-bottom {
    background-color: #fff;
    border-top-left-radius: 0.15rem;
    border-top-right-radius: 0.15rem;
    position: relative;
    top: -0.2rem;
    padding: 0.1rem 0.2rem 0.3rem 0.2rem;
    box-sizing: border-box;
    .border {
      border-bottom: 7px solid rgba(206, 203, 203, 0.4);
      padding-bottom: 0.3rem !important;
    }
    .bottom-item {
      display: flex;
      justify-content: space-between;
      padding-top: 0.2rem;
      .bottom-item-left {
        width: 100%;
        .bottom-item-left-title1 {
          color: #142323;
          font-size: 0.2rem;
          margin-bottom: 0.1rem;
          font-weight: 600;
        }
        .bottom-item-left-title2 {
          color: #868686;
          font-size: 0.15rem;
          margin-bottom: 0.07rem;
        }
      }
      .ma {
        width: 0.7rem;
        height: 0.7rem;
        text-align: center;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .order-item {
      padding-top: 0.25rem;
      .title {
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 0.17rem;
      }
      .details-item {
        margin-top: 0.14rem;
      }
      .desc {
        color: rgba(20, 35, 35, 0.5);
        font-size: 0.15rem;
        white-space: pre-wrap;
      }
    }
    .bottom-ticeket {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-top: 0.1rem;
      .ticeket-left {
        font-size: 0.18rem;
        font-weight: 600;
        line-height: 0.25rem;
      }
      .ticeket-right {
        display: flex;
        div {
          border-radius: 0.3rem;
          width: 0.85rem;
          text-align: center;
          font-size: 0.12rem;
          line-height: 0.25rem;
        }
        .cancel {
          border: 1px solid #2c7272;
          color: #2c7272;
          margin-right: 0.05rem;
        }
        .cancel1 {
          background-color: rgba(44, 114, 114, 0.2);
          color: #2c7272;
          line-height: 0.35rem;
          text-align: center;
          border-radius: 0.05rem;
          margin-top: 0.1rem;
          font-size: 0.15rem;
          font-weight: 700;
        }
        .pay {
          background-color: #2c7272;
          color: #fff;
        }
      }
    }
  }
  .pull {
    position: fixed;
    max-width: 768px;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .pull-con {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .pull-con-title1 {
      font-weight: 500;
      color: #142323;
      letter-spacing: 1px;
      font-size: 0.2rem;
      font-weight: 600;
      text-align: center;
    }
    .pull-con-title2 {
      margin-top: 0.2rem;
      font-size: 0.12rem;
      p {
        margin-bottom: 0.1rem;
        color: #142323;
        letter-spacing: 2px;
      }
    }
    .pull-button {
      width: 100%;
      line-height: 0.31rem;
      margin-top: 0.2rem;
      display: flex;
      justify-content: space-between;
      text-align: center;
      div {
        width: 40%;
        border-radius: 0.04rem;
      }
    }
  }
}
.imageMa {
  width: 100%;
  color: #535561;
  text-align: center;
  img {
    display: block;
    margin: 0 auto;
  }
  .title {
    font-size: 0.24rem;
    background-color: #fff;
    border-top-left-radius: 0.13rem;
    border-top-right-radius: 0.13rem;
    padding-top: 0.2rem;
  }
  .prompt {
    font-size: 0.22rem;
    background-color: #fff;
    color: #000;
    font-weight: 600;
    padding: 0.4rem 0 1rem 0;
    border-bottom-left-radius: 0.13rem;
    border-bottom-right-radius: 0.13rem;
    height: 1.5rem;
    letter-spacing: 0.03rem;
    p {
      line-height: 0.3rem;
    }
  }
  .Stitle {
    font-size: 0.2rem;
    background-color: #fff;
    padding-bottom: 0.2rem;
    border-bottom-left-radius: 0.13rem;
    border-bottom-right-radius: 0.13rem;
    font-weight: 700;
    padding-top: 0.1rem;
  }
  .cancel {
    width: 100%;
    position: absolute;
    .cancel-inner {
      border: 1px solid #fff;
      color: #fff;
      // padding: 0.15rem 0.4rem;
      width: 1.1rem;
      line-height: 0.4rem;
      border-radius: 0.3rem;
      font-size: 0.18rem;
      margin: 0.15rem auto;
    }
  }
}
</style>